<template>
    <ExtendedLayout
        :project="project"
        currentTab="open-house"
    >

        <Panel>

            <form @submit.prevent="submit">

                <ProjectFeedSelector
                    v-if="project.type === 'multi_feed'"
                    :project="project"
                    @select="selectedFeedId = $event"
                />

                <Heading type="h2">{{ __('admin::labels.location_for_open_house') }}</Heading>

                <FormGroup :label="__('admin::labels.address')">
                    <Input name="address" type="text" v-model="openHouse.address" :required="false" />
                </FormGroup>

                <div class="grid grid-cols-3 gap-4">
                    <FormGroup :label="__('admin::labels.zipcode')" :error="errors.zipcode">
                        <Input name="zipcode" type="text" :has-error="exists(errors.zipcode)" v-model="openHouse.zipcode" :required="false" />
                    </FormGroup>

                    <FormGroup :label="__('admin::labels.city')" :error="errors.city">
                        <Input name="city" type="text" :has-error="exists(errors.city)" v-model="openHouse.city" :required="false" />
                    </FormGroup>

                    <FormGroup :label="__('admin::labels.country')" :error="errors.country">
                        <Select name="country" :options="countryOptions" :has-error="exists(errors.country)" v-model="openHouse.country" :required="false" />
                    </FormGroup>
                </div>

                <Heading type="h2" class="mt-2">{{ __('admin::labels.dates') }}</Heading>

                <OpenHouseDates v-model="openHouse.settings" :weekDayOptions="weekDayOptions" :project-feed-id="selectedFeedId" />

                <Heading type="h2" class="mt-8">{{ __('admin::labels.disallowed_dates') }}</Heading>

                <p class="text-gray-600 mb-3" v-if="disallowedDatesString">
                    {{ __('admin::labels.globally_disallowed_dates') }}: {{ disallowedDatesString }}
                </p>

                <OpenHouseDisallowedDates v-model="openHouse.disallowed_dates" :project-feed-id="selectedFeedId" />

                <Button :loading="form.processing" class="mt-8">
                    {{ __('admin::general.update_model', {'model': __('admin::projects.project').toLowerCase() }) }}
                </Button>

            </form>

        </Panel>

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@/Pages/Projects/Edit';
import Panel from "@/Components/Panel";
import Button from "@/Components/Button";
import FormGroup from "@/Components/FormGroup";
import Input from "@/Components/Input";
import Select from "@/Components/Select";
import Heading from "@/Components/Heading";
import OpenHouseDates from "@/Components/OpenHouseDates";
import OpenHouseDisallowedDates from "@/Components/OpenHouseDisallowedDates";
import ProjectFeedSelector from "@/Components/ProjectFeedSelector";

export default {
    components: {
        ProjectFeedSelector,
        OpenHouseDisallowedDates,
        OpenHouseDates,
        Heading,
        Select,
        Input,
        FormGroup,
        Button,
        Panel,
        ExtendedLayout,
    },
    props: {
        errors: Object,
        project: Object,
        countryOptions: Object,
        weekDayOptions: Object,
        disallowedDatesString: String,
    },
    data() {
        return {
            form: this.$inertia.form({
                open_houses: [],
            }),
            selectedFeedId: null,
        }
    },
    computed: {
        openHouse() {
            return this.form.open_houses.find((x) => x.project_feed_id === this.selectedFeedId);
        },
    },
    created() {
        let openHouse = this.project.open_houses.find((x) => x.project_feed_id === null);
        this.form.open_houses.push({
            project_feed_id: null,
            address: openHouse?.address,
            zipcode: openHouse?.zipcode,
            city: openHouse?.city,
            country: openHouse?.country || 'DK',
            settings: openHouse?.settings || [],
            disallowed_dates: openHouse?.disallowed_dates || [],
        });

        this.project.feeds.forEach((item) => {
            openHouse = this.project.open_houses.find((x) => x.project_feed_id === item.id);
            this.form.open_houses.push({
                project_feed_id: item.id,
                address: openHouse?.address,
                zipcode: openHouse?.zipcode,
                city: openHouse?.city,
                country: openHouse?.country || 'DK',
                settings: openHouse?.settings || [],
                disallowed_dates: openHouse?.disallowed_dates || [],
            });
        });
    },
    methods: {
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    _method: 'patch',
                }))
                .post(this.$route('admin::projects.open-house.update', { project: this.project.id }));
        }
    },
}
</script>
